import { render, staticRenderFns } from "./multiLineText.vue?vue&type=template&id=10563b35&scoped=true"
import script from "./multiLineText.vue?vue&type=script&lang=js"
export * from "./multiLineText.vue?vue&type=script&lang=js"
import style0 from "./multiLineText.vue?vue&type=style&index=0&id=10563b35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10563b35",
  null
  
)

export default component.exports